function Ja(t, e) {
    return t || 0 === t ? e(t) : e;
}

function mapRange(e, t, r, i, n) {
    let a = t - e,
        s = i - r;
    return Ja(n, function (t) {
        return r + (((t - e) / a) * s || 0);
    });
}

function div(m, s) {
    let d = m / s;
    if (d > 16) {
        return div(m / 2, s);
    }
    return d;
}

function sv(m, d) {
    return Math.round(m / d);
}

function dsv(m, d) {
    return m % d;
}

const slider = function slider(s_id, param = null) {
    let range = "#" + s_id;

    let step    = $(range + " .slider-input").prop("step");
    let min     = $(range + " .slider-input").prop("min");
    let max     = $(range + " .slider-input").prop("max");
    let value   = $(range + " .slider-input").prop("value");
    let tMax    = max != 0 ? max - min : max;
    let division    = div(max, step);
    let sValue      = sv(max, division);
    
    let srInput = $(range).find('.slider-range');
    srInput.parent().find('.s-range').remove();
    srInput.parent().find('.slider-pointer').remove();
    srInput.parent().find('.s-range-selected').remove();

    let srDiv = '<div class="s-range"><ul class="slider-labels d-flex justify-content-between ">';

    let liHtml = '';
    let iValue = min != 0 ? (min / step) : 0;
    let length = (max / step) - iValue;
    
    for (let index = 0; index <= length; index++) {

        let result  = mapRange(0, tMax, 0, 100, index * step);
        let dStop   = iValue * step;
        let ds      = dsv(dStop, sValue);
        let dsValue = dStop;

        if (index != 0 && index != length && ds != 0) {
            dsValue = '';
        }
        liHtml += "<li data-stop='" + (dStop) + "' data-position = '" + result.toFixed(2) + "' style = 'left:" + result.toFixed(2) + "%' > <span class='slider-range-line'> </span> <span class='slider-range-label'> "+ dsValue +" </span></li>";
        iValue++;
    }

    srDiv += liHtml;

    srDiv += '</ul></div><div class="slider-pointer" data-position = ""></div><div class="s-range-selected">';

    srInput.parent().append(srDiv);

    let sliderRange     = ".slider-range-" + s_id;
    let sliderInput     = ".slider-input-" + s_id;
    let sliderLabels    = ".slider-labels-" + s_id;
    let sliderPointer   = ".slider-pointer-" + s_id;
    let sRange          = ".s-range-" + s_id;
    let sRangeSelected  = ".s-range-selected-" + s_id;

    $(range + " .slider-range").addClass("slider-range-" + s_id);
    $(range + " .slider-input").addClass("slider-input-" + s_id);
    $(range + " .slider-labels").addClass("slider-labels-" + s_id);
    $(range + " .slider-pointer").addClass("slider-pointer-" + s_id);
    $(range + " .s-range").addClass("s-range-" + s_id);
    $(range + " .s-range-selected").addClass("s-range-selected-" + s_id);

    if (param != null && param.hasOwnProperty('disable') && param.disable) {
        $(range).parent().addClass('disabled');
        $(range).parent().find('div').addClass('disabled');
    } else {
        $(range).parent().removeClass('disabled');
        $(range).parent().find('div').removeClass('disabled');
    }

    function sr() {
        let sr  = $(sRange).parent().find(".slider-range");
        let s   = sr.prop("step");
        let mn  = sr.prop("min");
        let mx  = sr.prop("max");
        let c   = 100 / ((mx - mn) / s);
        return c;
    }

    $(sRange).click(function (e) {
        let c       = sr();
        let pOffset = $(this).parent().offset();
        let l       = ((e.pageX - pOffset.left) / $(this).outerWidth()) * 100;
        let current = Math.round(l / c) * c;

        $(this).find("ul").find(`[data-position='${current.toFixed(2)}']`).trigger("click");
    });

    
    $(sRangeSelected).click(function (e) {
        let c       = sr();
        let pOffset = $(sRange).parent().offset();
        let l       = ((e.pageX - pOffset.left) / $(sRange).outerWidth()) * 100;
        let current = Math.round(l / c) * c;

        $(sRange).find("ul").find(`[data-position='${current.toFixed(2)}']`).trigger("click");
    });

    function pL(pageX) {
        let oW      = $(sRange).outerWidth();
        let pOffset = $(sRange).parent().offset();
        let rMP     = oW + pOffset.left;
        let pLeft   = pageX - $(sRange).parent().offset().left;
        if (pageX > rMP) {
            pLeft = oW;
        }

        if (pageX < pOffset.left) {
            pLeft = 0;
        }
        return pLeft;
    }

    function cP(pLeft) {
        $(sliderLabels + " li").removeClass('slider-line-in-range');
        let c = sr();
        let l = (pLeft / $(sRange).parent().find(".s-range").outerWidth()) * 100;
        let current = Math.round(l / c) * c;
        $(sRange).find("ul").find(`[data-position='${current.toFixed(2)}']`).trigger("click");

        $(sliderLabels + ` li[data-position='${current.toFixed(2)}']`).prevAll().addClass("slider-line-in-range");
    }

    $(document).on("mouseup", function (e) {
        e.stopPropagation();
        if ($(sliderPointer).hasClass("active")) {
            $(sliderPointer).removeClass("active");
            let pLeft = pL(e.pageX);
            cP(pLeft);
        }
    });

    $(document).on("mousemove", function (e) {
        e.stopPropagation();
        if ($(sliderPointer).hasClass("active")) {
            let pLeft = pL(e.pageX);
            let c = sr();
            let l = (pLeft / $(sRange).parent().find(".s-range").outerWidth()) * 100;
            let current = Math.round(l / c) * c;
            $(sliderPointer).css("left", parseInt(l) + "%");
            $(sliderPointer).attr("data-position", l);
            $(sRangeSelected).css("width", parseInt(l) + "%");

            $(sliderLabels + ' li').removeClass('slider-line-in-range');
            $(sliderLabels + ' li').removeClass("selected");

            $(sliderLabels + ` li[data-position='${current.toFixed(2)}']`).prevAll().addClass("slider-line-in-range");
            $(sliderLabels + ` li[data-position='${current.toFixed(2)}']`).addClass("selected");
        }
    });

    $(sliderPointer).on("mousedown", function (e) {
        e.stopPropagation();
        $(sliderPointer).addClass("active");
    });

    function setP() {
        let position = $(sliderRange).parent().find(".slider-labels li.selected").attr("data-position");
        $(sliderRange).parent().find(".slider-pointer").css("left", position + "%");
        $(sliderRange).parent().find(".slider-pointer").attr("data-position", position);
        $(sliderRange).parent().find(".s-range-selected").css("width", position + "%");
        $(sliderLabels + " li").removeClass('slider-line-in-range');
        $(sliderLabels + ` li[data-position='${position}']`).prevAll().addClass("slider-line-in-range");
    }

    $(sliderRange).on("input", function (e) {
        e.stopPropagation();
        $(sliderInput).prop("value", Number($(this).val()));
        setP();
    });

    $(sliderRange).on("change", function (e) {
        e.stopPropagation();
        $(this).parent().find("ul").find("li").removeClass("selected");
        $(this).parent().find("ul").find(`[data-stop='${$(this).val()}']`).addClass("selected");
        setP();
    });

    $(sliderInput).on("input", function (e) {
        e.stopPropagation();
        $(sliderRange).prop("value", Number($(this).val())).trigger("change");
        $(this).parent().parent().find("ul").find(`[data-stop='${$(this).val()}']`).trigger("click");
    });

    $(document).on("click", sliderLabels + " li", function (e) {
        e.stopPropagation();
        $(sliderLabels + " li").removeClass("selected");
        $(this).addClass("selected");
        $(sliderRange).prop("value", Number($(this).data('stop'))).trigger("change");
        $(sliderInput).prop("value", Number($(this).data('stop')));
    });

    let pos = $(sliderRange).parent().find(".s-range .slider-labels li.selected").attr("data-stop");
    $(sliderRange).parent().find("ul").find(`[data-stop='${pos}']`).trigger("click");
    $(sliderRange).prop("value", Number(value)).trigger("change");
}

export default {slider};

function autoRun() {
    slider("storage_size_div");
    slider("cpu_div");
    slider("additional_drive_3_div", {'disable': true, });
    slider("additional_drive_2_div", {'disable': true, });
    slider("additional_drive_1_div", {'disable': true, });
    slider("memory_size_div");
}
if (document.addEventListener)
    document.addEventListener("DOMContentLoaded", autoRun, false);
else if (document.attachEvent)
    document.attachEvent("onreadystatechange", autoRun);
else window.onload = autoRun;
